
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { MembershipFormData } from "../types";

interface ContactFieldsProps {
  form: UseFormReturn<MembershipFormData>;
}

export const ContactFields = ({ form }: ContactFieldsProps) => {
  return (
    <div className="space-y-4">
      <h3 className="font-semibold">Contact Numbers</h3>
      <div className="space-y-4">
        <div>
          <p className="mb-2">Mobile Number*</p>
          <div className="grid grid-cols-2 gap-4">
            <FormField
              control={form.control}
              name="mobileNumber.areaCode"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Area Code</FormLabel>
                  <FormControl>
                    <Input {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="mobileNumber.number"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Phone Number</FormLabel>
                  <FormControl>
                    <Input {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
        </div>

        <div>
          <p className="mb-2">Business Number</p>
          <div className="grid grid-cols-2 gap-4">
            <FormField
              control={form.control}
              name="businessNumber.areaCode"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Area Code</FormLabel>
                  <FormControl>
                    <Input {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="businessNumber.number"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Phone Number</FormLabel>
                  <FormControl>
                    <Input {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
